import { useState, useEffect, useContext } from 'react';
import { AppContext } from '../../context/context'
import UiButton1 from '../../components/ui_button1';
import UiInput1 from '../../components/ui_input1';
import UiSpinner from '../../components/ui_spinner';

const BrandAdd = () => {

    const {
        neonUser,
        getBrands,
        offCanvas,
        setToastContent,
        toastInit,
        hh,
        updateChecklist,
        brandList,
        fetchDataV2
    } = useContext(AppContext)

    const [selectedStatus, setSelectedSatus] = useState(null)
    const [accountTypeList, setAccountTypeList] = useState([])
    const [selectedAccountType, setSelectedAccountType] = useState("")
    const [brandName, setBrandName] = useState("")
    const [vendorRevenueType, setVendorRevenueType] = useState("")
    const [errorList, setErrorList] = useState([])
    const [generalMessage, setGeneralMessage] = useState("")
    const [loading, setLoading] = useState(false)
    const [hasSimilar, setHasSimilar] = useState(false)
    const [similarList, setSimilarList] = useState([])

    const getAccountType = async () => {
        let query1 = "GET_ACCOUNT_TYPE", params1 = []
        let resp = await fetchDataV2(query1, params1, "/neon-query-v2")
        setAccountTypeList(resp.map(x => x.unnest))
    }

    const similar = (str, arr, rate = 50) => {
        let res = arr
            .map(val => ({
                value: val,
                score: (() => {
                    const a = new Set(str.toLowerCase().split(" "));
                    const b = new Set(val.toLowerCase().split(" "));
                    const intersection = new Set([...a].filter(w => b.has(w)));
                    const union = new Set([...a, ...b]);
                    return +(intersection.size / union.size * 100).toFixed(1);
                })()
            }))
            .filter(x => x.score >= rate)
            .sort((a, b) => b.score - a.score);
        return res
    }

    const createBrand = async (create = false) => {
        setSimilarList([])

        if (!create) {
            let found = similar(brandName, brandList.map(x => x.brand), 20)
            if (found.length > 0) {
                setSimilarList([...new Set(found.map(x => x.value))])
                setHasSimilar(true)
                return
            }
        }

        setHasSimilar(false)
        setLoading(true)
        setErrorList([])
        setGeneralMessage("")

        let valid = true
        let data = { brandName, selectedStatus, selectedAccountType }
        let err = []
        Object.keys(data).forEach(x => {
            if ([undefined, null, ""].includes(data[x])) {
                err.push(x)
                valid = false
            }
        })
        setErrorList(err)

        if (!valid) {
            setGeneralMessage("Required fields must not be empty.")
            setLoading(false)
            return
        }

        let query1 = "CREATE_BRAND_1", params1 = []
        let newId = await fetchDataV2(query1, params1, "/neon-query-v2")

        let query2 = 'CREATE_BRAND_2', params2 = [
            data.brandName,
            data.selectedStatus,
            Number(newId[0].max) + 1,
            selectedAccountType,
            '{ppc}',
            vendorRevenueType,
            neonUser.agency.agency_id
        ]

        let resp = await fetchDataV2(query2, params2, "/neon-query-v2")

        if (!resp || resp.length == 0) {
            setGeneralMessage("Error! Please try again.")
            setLoading(false)
            return
        }

        setLoading(false)
        setGeneralMessage("Account/Brand Successfully Created.")
        setBrandName("")
        setSelectedSatus(null)
        setSelectedAccountType("")
        getBrands()
        offCanvas.hide()
        setToastContent("Account/Brand Successfully Created.")
        toastInit.show()
    }

    useEffect(() => {
        getAccountType()
    }, [])

    if (accountTypeList.length == 0) return (
        <div className="d-flex justify-content-center" style={{ height: hh / 2 }}>
            <UiSpinner />
        </div>
    )

    if (hasSimilar && similarList.length > 0) return (
        <div className="d-flex flex-column justify-content-between h-100">
            <div className="d-flex flex-column gap-3 h-100">
                <p className="mb-0 fw-bold poppins">Brand name '<span className='text-danger'>{brandName}</span>' may already exist.</p>
                <ul>
                    {similarList.map(x => (
                        <li key={x} className='poppins mb-1'>
                            {brandList.filter(xx => xx.brand == x)[0].brand} - {brandList.filter(xx => xx.brand == x)[0]['active?'] ?
                                <span className='fw-bold text-success'>Active</span>
                                :
                                <span className='fw-bold text-danger'>Inactive</span>
                            }
                        </li>
                    ))}
                </ul>
            </div>
            <div className='d-flex gap-2'>
                <UiButton1 text="Cancel" type={2} submit={() => { setHasSimilar(false); setSimilarList([]) }} />
                <UiButton1 text="Continue" submit={() => createBrand(true)} />
            </div>
        </div>
    )

    return (
        <div className="d-flex flex-column justify-content-between h-100">
            <div className="d-flex flex-column gap-4">
                <div className="d-flex flex-column gap-2">
                    {generalMessage && <p className={errorList.length > 0 ? "poppins text-danger" : "poppins text-success"}>{generalMessage}</p>}
                    <p className="mb-0 fw-bold poppins">Account/Brand Name</p>
                    <UiInput1 value={brandName} userChangeHandler={setBrandName} />
                </div>

                <div className="d-flex flex-column gap-2">
                    <p className="mb-0 fw-bold poppins">Account Type</p>
                    <div className="d-flex gap-3">
                        {accountTypeList.map(x => (
                            <div key={x} className="d-flex gap-3">
                                <input type="radio" name="account_type" className="input-radio align-self-center" checked={selectedAccountType == x} onChange={e => setSelectedAccountType(x)} />
                                <span className="poppins align-self-center text-capitalize">{x == 'ads' ? "Ads Only" : x}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="d-flex flex-column gap-2">
                    <p className="mb-0 fw-bold poppins">Account/Brand Status</p>
                    <div className="d-flex gap-3">
                        <input type="radio" name="status" className="input-radio align-self-center" checked={selectedStatus == true} onChange={e => setSelectedSatus(true)} />
                        <span className="poppins align-self-center">Active</span>

                        <input type="radio" name="status" className="input-radio align-self-center" checked={selectedStatus == false} onChange={e => setSelectedSatus(false)} />
                        <span className="poppins align-self-center">Inactive</span>
                    </div>
                </div>
            </div>

            {loading ?
                <UiSpinner />
                :
                <UiButton1 text="Save" submit={() => createBrand()} />
            }
        </div>
    )
}

export default BrandAdd